import React, { useContext, useEffect} from 'react'
import {Divider} from 'semantic-ui-react'
import { observer } from 'mobx-react-lite'
import LoadingComponent from '../../../App/layout/LoadingComponent'
import { RootStoreContext } from '../../../App/stores/RootStore'
import RequestFilters from './RequestFilters'
import RequestListTable from "./RequestListTable";

const RequestDashboard: React.FC = () => {
    const rootStore = useContext(RootStoreContext)
    const { initLoadTableRequests, loadingInitial  } = rootStore.requestStore;
    // const [, setLoadingNext] = useState(false);


    useEffect(() => {
        initLoadTableRequests();
    }, [initLoadTableRequests]);

    return (
        <>
            <RequestFilters />
            <Divider/>
            <LoadingComponent active={loadingInitial} content='Loading Requests...' />
            <RequestListTable />
        </>
    )
}
export default observer(RequestDashboard);